import "aos/dist/aos.css";
import { ExternalLink } from "lucide-react";

const HeroSection = () => {
  const images = [
    "https://media.licdn.com/dms/image/v2/D5612AQEl5oIja1BDAg/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1695535071929?e=2147483647&v=beta&t=I6OjWre2m9P-muDyqLZGctQCaphz9_G5El7ym0kP2sE",
    "https://img.freepik.com/free-vector/user-panel-template-infographic-dashboard_23-2148378206.jpg",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLgKoiJ_zT_mYkrpCTbP26L4cp46MLrU7X_2L9KDrhVhmcP6BUAo3NHbah8at8zqWCrGI&usqp=CAU",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRPpSdhiCD_hqptSunKU5l4mNLToMev8N4sQ&s",
    "https://media.istockphoto.com/id/1488294044/photo/businessman-works-on-laptop-showing-business-analytics-dashboard-with-charts-metrics-and-kpi.jpg?s=612x612&w=0&k=20&c=AcxzQAe1LY4lGp0C6EQ6reI7ZkFC2ftS09yw_3BVkpk=",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnCcoHWsz4ZqsdiKexEQJqG1txMSGJMPUlsuiz2xbbaPC_Z24oU-f1_MqPVQOPlU90mpg&usqp=CAU",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSeaiJF23EyBdG5-d7EQ5JwapUKZckQoxjuBfQkbwCmiagFCPdaogcTPV7gsYcqBc1ueE&usqp=CAU",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSfi-urCbko9bv3wp4ga-eOlZOE9N8jQ780xA&s",
  ];

  return (
    <>
      <section className="px-[5%]">
        <div className="max-w-7xl mx-auto my-14 bg-white grid grid-cols-1 lg:grid-cols-2 gap-6 items-center py-2">
          {/* <!-- Text Column --> */}
          <div className="">
            <h2 className="text-2xl md:text-4xl font-bold mt-2 mb-3 leading-snug md:leading-relaxed bg-gradient-to-r from-[#0d6b68] to-[#0d6b68] bg-clip-text text-transparent">
              VETRI Dashboard – Smart Institution Management Made Simple
            </h2>

            <h3 className="text-lg text-gray-500 mt-4">
              VETRI Dashboard helps schools, colleges, and universities manage
              every academic and administrative task in one powerful platform.
              It reduces manual effort, improves transparency, and empowers
              management with real-time insights
            </h3>
            <div className="flex flex-wrap gap-4 mt-4">
              <a
                href="tel:+917994670962"
                className="btn1 group inline-flex items-center gap-3"
              >
                <span className="font-medium transition">
                  Get our expert advice
                </span>
                <ExternalLink className="w-4 h-4 transition-transform group-hover:translate-x-1 duration-200" />
              </a>
            </div>
          </div>
          <div className="relative bg-transparent flex justify-center items-center overflow-hidden rounded-2xl p-4 h-[300px]">
            <div className="scope w-[240px] h-[140px]">
              {images.map((img, i) => (
                <span key={i} style={{ "--i": i + 1 }}>
                  <img
                    src={img}
                    alt={`gallery-${i}`}
                    className="rounded-xl"
                    loading="lazy"
                  />
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
